const FormUIOptions = {
  Text: 'text',
  TextArea: 'TextArea',
  PercentTextInput: 'PercentTextInput',
  Number: 'Number',
  Select: 'Select',
  Money: 'Money',
  Place: 'Place',
  Date: 'Date',
  Radio: 'Radio',
  RadioBigGroup: 'RadioBigGroup',
  YesNoExplain: 'YesNoExplain',
  YesNo: 'YesNo',
  Explain: 'Explain',
  Calculated: 'Calculated',
  UnitText: 'UnitText',
  Toggle: 'Toggle',
  UnitMoney: 'UnitMoney',
  UnitTime: 'UnitTime',
  selectOptions: {
    monthly: ['monthly', 'yearly'],
    percentage: ['%', 'amount'],
    monthYearPercent: ['monthly', 'yearly', '%'],
    weekMonth: ['weeks', 'months'],
  },
  Table: 'Table',
  BeforeAfterTableInline: 'BeforeAfterTable',
  BeforeAfterTableModal: 'BeforeAfterTableModal',
  BeforeAfter: 'BeforeAfter',
  TableModal: 'TableModal',
  TableInline: 'TableInline',
  PictureGallery: 'PictureGallery',
  Email: 'email',
  Telephone: 'tel',
  Header: 'Header',
  Label: 'Label',
  LinkButton: 'LinkButton',
  Blank: 'Blank',
  CalculatedSection: 'CalculatedSection',
};

export default FormUIOptions;
